import axios from "axios";
import { API_BASE_URL } from "../../apiConfig";

export async function refreshTokenIfNeeded() {
  const token = localStorage.getItem("token");
  const refresh = localStorage.getItem("refresh");

  if (!token || !refresh) return null;

  // // تحقق من انتهاء التوكن
  // const jwtPayload = JSON.parse(atob(token.split(".")[1]));
  // const exp = jwtPayload.exp * 1000; // الوقت بالمللي ثانية
  // const now = Date.now();

  // if (now < exp - 10000) {
  //   // التوكن صالح، أقل من 10 ثواني قبل الانتهاء
  //   return token;
  // }

  // التوكن منتهي أو على وشك الانتهاء، نجدد
  try {
    const response = await axios.post(`${API_BASE_URL}Auth/refresh`, {
      refreshToken: refresh,
      userName: localStorage.getItem("userName"),
    });

    localStorage.setItem("token", response.data.accessToken);
    localStorage.setItem("refresh", response.data.refreshToken);

    return response.data.accessToken;
  } catch (err) {
    // التوكن غير صالح أو انتهى، سجل خروج
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");
    return null;
  }
}
